/*
    2019-11-04
    曹秀芳
    制作FailureTime页面.
    
*/ 
<template>
  <div class="FailureTime mainWrap"><!--需要修添加class-->
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/FT001"></leftNav><!--改组件名-->
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <a download=""></a>
          <el-main>
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('leftNav.navtwentieth')}}</h1>
                <div class="rightWrap">
                    <label style="margin-right:10px;font-size:12px;">{{$t('EquipmentSpecificationInformation.label1')}}</label>
                    <ul style="display:flex;">
                        <li v-for="item in options" :key="item.value" class="everyWorkShop" :class="{'activeWorkShop':item.value == onevalue}" @click="changeLine(item)">
                            {{item.label}}
                        </li>
                    </ul>
                </div>
              </div>
              <!-- 页面主体部分-->
              <div class="my"  v-loading='ReportLoading'>
                <div class="FailureTime-body">
                  <!-- 下载按钮 -->
                  <div style="height:75px;" class="dataLine">
                   
                    <div class="dataPicker" style="line-height:75px;" > 
                      <el-date-picker
                        v-model="choosedDate"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        @change="ChangedDataReportTable"
                        :picker-options="pickerOptions"
                        range-separator="-"
                        :start-placeholder="$t('gantt.StartTime')"
                        :end-placeholder="$t('gantt.EndTime')"
                        :default-time="['00:00:00', '00:00:00']">
                      </el-date-picker>
                    </div>
                    <div class="downBotton">
                      <el-row>
                        <el-button size="small" @click="clickExport"><downloadIcon style="font-size:14px;" title=""/> {{$t('EventRecord.Export')}}</el-button>
                      </el-row>
                    </div>
                  </div>
                  <el-table
                    stripe
                    :data="tableData"
                    height="498"
                    ref="policeTable"
                    :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                    :class="{'tableWidth1':tabletitle.length !== 1,'tableWidth2':tabletitle.length === 1}"
                    >
                    <el-table-column
                      fixed
                      prop="start"
                      width="290">
                      <el-table-column
                        align="center"
                        prop="start"
                        :label="$t('FailureTimeStatistics.date')"
                        width="110">
                          <template slot-scope="scope">
                            <span>{{scope.row.start | formatDate}}</span>
                          </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="start"
                        :label="$t('FailureTimeStatistics.StartTime')"
                        width="90">
                          <template slot-scope="scope">
                            <span>{{scope.row.start | formatTime}}</span>
                          </template>
                      </el-table-column>
                      <el-table-column
                        align="center"
                        prop="start"
                        :label="$t('FailureTimeStatistics.EndTime')"
                        width="90">
                          <template slot-scope="scope">
                            <span>{{scope.row.end | formatTime}}</span>
                          </template>
                      </el-table-column>
                    </el-table-column>
                    <el-table-column
                      v-for="item in tabletitle"
                      :key="item.label"
                      :prop="item.prop"
                      :label="item.label"
                      align="center"
                      >
                        <el-table-column
                          align="center"
                          :label="$t('FailureTimeStatistics.Production')"
                          >
                            <template slot-scope="scope">
                              <span>{{scope.row.failureTimeLogList[item.prop][0]}}</span>
                            </template>
                        </el-table-column>
                         <el-table-column
                          align="center"
                          :label="$t('FailureTimeStatistics.FaultTimes')"
                          >
                            <template slot-scope="scope">
                              <span>{{scope.row.failureTimeLogList[item.prop][1]}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                          align="center"
                          :label="$t('FailureTimeStatistics.FailureTotalTime')"
                          >
                            <template slot-scope="scope">
                              <span>{{scope.row.failureTimeLogList[item.prop][2]+"'"}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                          align="center"
                          :label="$t('FailureTimeStatistics.FailureEffectiveTime')"
                          >
                            <template slot-scope="scope">
                              <span>{{scope.row.failureTimeLogList[item.prop][3]+"'"}}</span>
                            </template>
                        </el-table-column> 
                    </el-table-column>
                  </el-table>
                </div>
                <footer class="footer">
                  <div class="footer-el" v-if="!noMachine">
                    <el-pagination
                      background
                      layout="prev, pager, next"
                      :total="total"
                      :page-size="nowPageSize"
                      :picker-options="pickerOptions"
                      :current-page.sync="nowPage"
                      @current-change="handleCurrentChange"
                      @size-change="handleCurrentSizeChange"
                    >
                    </el-pagination>
                  </div>
                </footer>
              </div>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import leftNav from "@/components/nav.vue"
import downloadIcon from "vue-material-design-icons/Download.vue"
//引入转换时间文件
import { formatDate } from '../assets/js/date.js'

export default {
  name: 'FT001',
  components: {
    leftNav,
    downloadIcon
  },
  data () {
    return {
      // 选中的机械id
      machineID: [],
      // 选中的工厂id
      factoryId:'',
      fullscreenLoading: false,
      //我的代码
      tabletitle:[],
      tableData: [],
      // 局部刷新
      ReportLoading: false,
      // 当前页数
      total:0,
      nowPage: 1,
      nowPageSize: 24,
       //选择的时间段
      choosedDate: [],
      pickerMinDate: '',
      //选中的开始时间与结束时间
      startTime:'',
      endTime:'',
      //日期选择器默认开始结束日期
      startData: '',
      endData:'',
      //选择范围20天
      pickerOptions: {
        onPick: ({minDate}) => {
          this.pickerMinDate = minDate.getTime()
        },
        disabledDate: (time) =>{
          // if (this.pickerMinDate !== '') {
            const day30 = 20 * 24 * 3600 * 1000
            let today=new Date().getTime()
            let maxTime = today
            let minTime = today - day30
            return (time.getTime() > maxTime ||
                      time.getTime() < minTime)
          // }
          
        }
      },
      // 车间数组
      options:[],
      shopId: null,
      // 默认车间的显示
      onevalue:'',
      noMachine:true
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
      }
    }
  },
  mounted() {
    this.shopId = this.$store.state.defaultShopId
    this.$store.commit('authority' , this.$route.path)
    this.getShopList()
    this.factoryId = this.$store.state.defaultFactoryId
    this.ReportTable()
  },
  destroyed() {
  },
  methods: {
    // 获取车间列表
    getShopList() {
      let _this = this
      this.axios({
          method: 'get',
          url: '/url/selectChooseShop',
          params:{
              language: _this.$store.state.lang,
              shopId:_this.$store.state.defaultShopId
          }
      }).then(function(res){
          if (res.data.success === 'true') {
            if(res.data.options !==undefined && res.data.options.length > 0 ){
              _this.noMachine=false
              if (res.data.belong === 1) {
                  if(localStorage.getItem('isMarketAccount') === '1') {
                      _this.$store.commit('marketAccountShop',res.data.options)
                  }
                  _this.options = res.data.options[0].children
                  // _this.onevalue = _this.options[0].value
                  _this.onevalue = _this.$store.state.defaultShopId
              } else{
                  _this.$router.push({path: '/login', name: 'login'})
              }
            }else{
              // _this.options = res.data.options
              _this.noMachine=true
              _this.$message(_this.$t('Dailyequipment.noEquipmentData'));
              _this.$store.commit('loginOut')
              _this.$router.replace({
                  path: '/login'
              })
            }
          } else {
              _this.$message.error('Machine list loading failed')
          }
      })
    },
    // 改变车间触发
    changeLine(item){
      this.onevalue=item.value
      this.shopId = item.value
      this.nowPage = 1
      this.ReportTable()
    },
    //我的代码s
    //日期选择改变触发的方法
    ChangedDataReportTable(){
      this.nowPage = 1
       if(this.choosedDate==null||this.choosedDate.length==0){
          this.startTime=''
          this.endTime=''
          this.ReportTable()
       }else{
          this.startTime=this.choosedDate[0]
          this.endTime=this.choosedDate[1]
          this.ReportTable()
       }
    },
   //请求表格的数据
   ReportTable(){
  // if(this.noMachine)return
    let _this = this
    _this.tabletitle=[]
    _this.tableData=[]
    this.ReportLoading = true
    this.axios({
      method: 'post',
      url: '/url/getfailureTimeStatistics',
      params:{
        language: _this.$store.state.lang,
        factoryId: _this.factoryId,
        pageSize:_this.nowPageSize,
        pageNum:_this.nowPage,
        conditionStartTime:this.startTime,
        conditionEndTime:this.endTime,
        shopId: _this.shopId,
      }
    }).then(function(res){
      console.log(res.data.success)
      if(res.data.success===false){
        _this.noMachine=true
      }else{
        _this.noMachine=false
        let arr= Object.keys(res.data);
        if(arr.length!=0){
          if(arr.includes('tableTitle')&&arr.includes('leftTitle')&&arr.includes('total')){
            _this.tabletitle = res.data.tableTitle
            _this.tableData = res.data.leftTitle
            _this.total = res.data.total
          }else{  
          }
        }else{
          
        }
      }
    }).then(function(){
      if(_this.noMachine==false){
        // setTimeout(() => {
            _this.$nextTick(() => {
                _this.$refs.policeTable.doLayout()
            })
        // }, 300)
      }
      _this.ReportLoading = false
    })  
    },
    // 分页
    handleCurrentChange (val) {
      this.nowPage = val
      this.getEventRecordListPage()
    },
    getEventRecordListPage () { 
      this.loading = true
      //调用请求表格的数据
      this.ReportTable()
    },
    handleCurrentSizeChange (val) {
      this.nowPageSize = val
      this.getEventRecordList()
    },
    //点击导出按钮进行判断
    clickExport(){
      if(this.choosedDate==null||this.choosedDate.length == 0){
        this.startTime=''
        this.endTime=''
        this.btn_export()
      }else{
        this.startTime=this.choosedDate[0]
        this.endTime=this.choosedDate[1]
        this.btn_export()
      }
    },
    // 导出功能
    btn_export () {
      // let dataType = this.becomeNum()+''
      if(this.tableData == null || this.tableData.length == 0){
        this.$message.error(this.$t('gantt.error'));
      }else{
        let signTime = new Date().getTime()
        this.$store.commit('nowsign', signTime)
        this.urlData = '?language=' + this.$store.state.lang + '&factoryId=' + this.factoryId +'&shopId='+this.shopId +'&sign='+this.$store.state.sign +'&conditionStartTime='+this.startTime+'&conditionEndTime='+this.endTime+'&auth_Code='+this.$store.state.authCode+'&sign_time='+signTime+'&route='+this.$store.state.newroute+'&factory_id='+this.$store.state.factoryId
        window.open('/download/failureTimeStatisticsExportLog' + this.urlData, '_blank')
      }
    },
  },
  filters: {//转换时间发方法
    formatDate (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, 'yyyy/MM/dd')
    },
    formatTime (time) {
      if (time === null || time === '') {
        return ''
      }
      var date = new Date(time)
      return formatDate(date, ' hh:mm')
    }
  }
}
</script>
<style scoped>
.FailureTime{
   min-width: 1365px!important;/*最小宽度 */
}
.mainWrao{
  height: 100%;
  width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
  display:flex;
  justify-content: space-between;
  align-items: center;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 10px;
}
.seach button{
  float: right;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.recordTitle .machineSeach{
  float: right;
}
.mainWrao .rightWrap{
  float: right;
  display:flex;
  align-items: center;
}
.rightWrap .everyWorkShop{
  border: 1px solid #409EFF;
  border-radius: 10px;
  padding: 0px 10px;
  color:#409EFF;
  margin-right:10px;
  cursor: pointer;
}
.rightWrap .activeWorkShop{
  background:#409EFF;
  color:#fff;
}
/* 我的样式 */
.flexes{
    display: flex;
}
.scroll{
  overflow: auto;
}
.FailureTime-body{
    width: 94%;
    margin: 5px auto 0;
}
.FailureTime-th{
    color: rgba(0, 0, 0, 0.85);
}
.FailureTime-th-left{
    border-right:1px solid rgba(166, 166, 166, 1);
}
.FailureTime-th-bottom{
    border-top:1px solid rgba(166, 166, 166, 1);
    font-size: 12px;
    line-height: 150%;
}
.FailureTime-th-bottom div{
    padding: 10px 0;
    white-space:nowrap;
}
.FailureTime-td-left{
  border-top:1px solid rgba(166, 166, 166, 1);
  font-size: 12px;
  line-height: 150%;
  padding: 8px 0;
}
.FailureTime-left div{
    width: 80px;
    text-align: center;
}
.FailureTime-th-right{
    border-left:1px solid rgba(166, 166, 166, 1);
}
.scroll li:nth-child(1) .FailureTime-th-right{
  border:none;
}
.empty{
  color: #fff;
}
.th-title{
    text-align: center;
    font-size: 16px;
    line-height: 150%;
    font-weight: bold;
}
.FailureTime-td-right{
  border-top:1px solid rgba(166, 166, 166, 1);
  padding: 8px 0;
}
.FailureTime-right div{
    width: 80px;
    text-align: center;
    font-size: 12px;
    line-height: 150%;
}
.FailureTime-right div:nth-child(3){
  width: 120px;
}
.FailureTime-right div:nth-child(4){
  width: 140px;
}
.dataLine{
  display: flex;
  flex-direction: row;
  justify-content:  space-between ;
}
.downBotton{
  margin: 15px 0;
  float: right;
}
.tableWidth1{
  width: 100%;
}
.tableWidth2{
  width: 100%;
}
.el-pagination{
  text-align: center;
}
.footer{
  width: 94%;
  margin: 30px auto;
  height: 113px;
  background: #fff;
}
.footer-el{
  padding-top: 40px;
  width: 410px;
  margin: 0 auto;
}
/* element-ui样式 */
</style>

